import React, { useEffect, useCallback, useState } from 'react';
import L from 'leaflet';
import AvatarOverlay from '../AvatarOverlay';
import { useSelector, useDispatch } from 'react-redux';
import { setOpenModal } from "../../../../ControlPanel/store/controlPanelSlice.js";
import { intializeMessageDialog } from '../../../../../store/messagesSlice/messagesSlice.js';
import { EXCLUDE_USER, FIRE_GUEST, POKE_USER } from '../../../store/Avatars/AvatarsSlice';
import { mapSocketFactory } from '../../../../../utils/socketFactory.js';
import { deactivateInvitationByAvatarId, deactivateInvite, findGuestTokenByEmail } from '../../../../ControlPanel/store/Invite/inviteThunk.js';
import ActionConfirmation from '../../../../../components/ActionConfirmation';
import { getInitialAvatar } from '../../../../../utils/stringUtils.js';
import { hasPermission, tenantHasFeature } from '../../../../Auth/utils/AuthUtils.js';
import './Avatar.css';
import { useTranslation } from 'react-i18next';
import { toggleLivekitMic } from '../../../../MediaPlayback/store/livekitSlice/livekitSlice.js';
import { setMicLoading } from '../../../../MediaControls/store/mediaControlSlice.js';
import { toggleGlobalLivekitMic } from '../../../../MediaPlayback/store/GlobalLivekitSlice/GlobalLivekitSlice.js';
import { setIsSuperSpeakerActive } from '../../../../ControlPanel/store/Announcement/AnnouncementSlice.js';
import badIcon from '../../../../../assets/connection_quality_bad.svg';
import mediumIcon from '../../../../../assets/connection_quality_medium.svg';
import goodIcon from '../../../../../assets/connection_quality_good.svg';
import { virerUser } from '../../../store/MapDisplayThunks.js';
import { triggerHaloAnimation } from '../../../../../utils/haloUtils.js';
import { useHaloSocket } from '../../../../../hooks/useHaloSocket.js';
import coffe from "../../../../../assets/coffe.svg"
import { Track, ParticipantEvent, RoomEvent } from 'livekit-client';
import { livekitRoomRef } from '../../../../../utils/livekitRef.js';
import Modal from "../../../../../features/ControlPanel/components/modal/Modal.jsx";
import ProfileInfo from "../../../../../features/ControlPanel/components/Profile-info/ProfileInfo.jsx";


function useMobile() {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if (typeof window === "undefined") return;
        const handleResize = () => {
            setIsMobile(window.innerWidth < 480);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
}

const pickConnectionQualityIcon = (quality) => {
    switch (quality) {
        case "excellent":
            return goodIcon;
        case "good":
            return mediumIcon;
        case "poor":
        default:
            return badIcon;
    }
};

const Avatar = ({ chair, avatar, avatarBounds, mapRef, overlays, zoomLevel, mapConfig }) => {

    const { globalLivekitMic } = useSelector((state) => state.globalLivekit)
    const { localAvatar, permissions } = useSelector((state) => state.auth);
    const [connectionQuality, setConnectionQuality] = useState("unknown");
    const connectionQualityIcon = pickConnectionQualityIcon(connectionQuality);

    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmDialogMiCOpen, setconfirmDialogMicOpen] = useState(false);
    const [ConfirmFireUserDialogOpen, setConfirmFireUserDialogOpen] = useState(false);

    const { currentRoom } = useSelector((state) => state.MapDisplay);
    const { avatars } = useSelector((state) => state.avatars);

    const [selectedAvatar, setSelectedAvatar] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { t } = useTranslation();

    const dispatch = useDispatch();
    const [timeLeft, setTimeLeft] = useState("");
    const [progress, setProgress] = useState(0);

    const {

        cafePauseActive,
        cafePauseStartTime,
        cafePauseDuration
    } = useSelector((state) => state.coffePause);
const getStartTimeInMs = (timeString) => {
    if (!timeString) return null;

    if (timeString.includes('T')) {
        return new Date(timeString).getTime(); 
    }
    const parts = timeString.split(':');
    const d = new Date();
    d.setHours(parseInt(parts[0]), parseInt(parts[1]), parseInt(parts[2]), 0);
    return d.getTime();
};
    const isMobile = useMobile();
    const [isSameRoom, setIsSameRoom] = useState(false);

    useEffect(() => {
        if (!chair || !currentRoom) {
            setIsSameRoom(false);
            return;
        }
        const same =
            String(chair.room_id) === String(currentRoom.room_id)
        setIsSameRoom(same);
    }, [chair, currentRoom]);

    const [videoTrack, setVideoTrack] = useState(null);

    useEffect(() => {
        if (!isSameRoom || !avatar?.email || !livekitRoomRef.current || !isMobile) {
            setVideoTrack(null);
            return;
        }

        const room = livekitRoomRef.current;

        const updateTrack = () => {
            if (avatar?.camera_state === 0) {
                setVideoTrack(null);
                return;
            }

            const participant = room.localParticipant.identity === avatar.email
                ? room.localParticipant
                : Array.from(room.remoteParticipants.values()).find(p => p.identity === avatar.email);

            if (!participant) {
                setVideoTrack(null);
                return;
            }

            const cameraPub = participant.getTrackPublication(Track.Source.Camera);
            setVideoTrack(cameraPub?.track || null);
        };

        updateTrack();

        const handleTrackEvent = (...args) => {

            const p = args.find(arg => arg && arg.identity);
            if (p && p.identity === avatar.email) {
                updateTrack();
            }
        };

        room.on(RoomEvent.TrackSubscribed, handleTrackEvent);
        room.on(RoomEvent.TrackUnsubscribed, handleTrackEvent);
        room.on(RoomEvent.LocalTrackPublished, handleTrackEvent);
        room.on(RoomEvent.LocalTrackUnpublished, handleTrackEvent);
        room.on(RoomEvent.ParticipantConnected, handleTrackEvent);

        return () => {
            room.off(RoomEvent.TrackSubscribed, handleTrackEvent);
            room.off(RoomEvent.TrackUnsubscribed, handleTrackEvent);
            room.off(RoomEvent.LocalTrackPublished, handleTrackEvent);
            room.off(RoomEvent.LocalTrackUnpublished, handleTrackEvent);
            room.off(RoomEvent.ParticipantConnected, handleTrackEvent);
        };
    }, [isSameRoom, avatar?.email, avatar?.camera_state, isMobile]);

useEffect(() => {
    if (!avatar?.break_coffe_time) {
        setTimeLeft("");
        setProgress(0);
        return;
    }

    let startTimeMs;
    const rawTime = avatar.break_coffe_time;

    if (rawTime.includes('T') || rawTime.includes('-')) {
        startTimeMs = new Date(rawTime).getTime();
    } else {
        const [hours, minutes, seconds] = rawTime.split(':');
        const d = new Date();
        d.setHours(parseInt(hours), parseInt(minutes), parseInt(seconds || 0), 0);
        startTimeMs = d.getTime();
    }

    if (isNaN(startTimeMs)) {
        console.error("Format de date invalide:", rawTime);
        return;
    }

    const durationInMs = (cafePauseDuration || 10) * 60 * 1000;

    const updateTimer = () => {
        const now = Date.now(); // Temps universel actuel
        const elapsed = now - startTimeMs;
        const remainingMs = durationInMs - elapsed;

        if (remainingMs <= 0) {
            setProgress(100);
            setTimeLeft("00:00");
            return;
        }

        const percent = Math.min(Math.max((elapsed / durationInMs) * 100, 0), 100);
        setProgress(percent);

        const totalSeconds = Math.ceil(remainingMs / 1000);
        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;

        setTimeLeft(`${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`);
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
}, [avatar?.break_coffe_time, cafePauseDuration]);






    const handleHalo = useCallback((level) => {
        const element = overlays.current[`avatar-${avatar.id}`]?.getElement();

        triggerHaloAnimation(element, avatar.id, level, 'manual');
    }, [avatar, overlays]);
    useHaloSocket(avatar?.id, handleHalo);

    // Écouter la qualité de connexion via mapSocketFactory pour gérer les reconnexions auto
    useEffect(() => {
        const eventName = `connectionQuality-${avatar.id}`;
        console.log("Avatar ID:", avatar.id);
        const handleQualityUpdate = ({ data }) => {
            if (data?.quality !== undefined) {
                setConnectionQuality(data.quality);
            }
        };

        // Utiliser le wrapper .on() de la factory qui gère les changements de socket
        mapSocketFactory.on(eventName, handleQualityUpdate);

        return () => {
            mapSocketFactory.off({ eventName, actionId: handleQualityUpdate.name || 'anonymous' });
            mapSocketFactory.offAll(eventName);
        };
    }, [avatar?.id]);


    const handleMessageClick = useCallback((event) => {
        event.stopPropagation();
        dispatch(intializeMessageDialog({ isRoom: false, target: avatar }));
        dispatch(setOpenModal("message_history"));
    }, [avatar]);



    const handlePokeClick = useCallback((event) => {
        event.stopPropagation();
        dispatch(POKE_USER({
            sender: localAvatar?.display_name,
            recipient: avatar?.email,
            targetFullName: avatar?.display_name
        }));
    }, [dispatch, localAvatar, avatar]);

    const handleFireClick = useCallback((event) => {
        event.stopPropagation();
        setConfirmDialogOpen(true);
    }, []);

    const handleFireUserClick = useCallback((event) => {
        event.stopPropagation();
        setConfirmFireUserDialogOpen(true);
    }, []);


    const handleCloseMicClick = useCallback((event) => {
        event.stopPropagation();
        setconfirmDialogMicOpen(true);
    }, []);
    const handleConfirmCloseMic = () => {
        if (mapSocketFactory && mapSocketFactory.socket && avatar?.email) {
            if (!mapSocketFactory.socket.connected) {
                console.error("⛔ ÉCHEC ÉMISSION: La socket est déconnectée ou en reconnexion.", {
                    id: mapSocketFactory.socket.id,
                    ready_state: mapSocketFactory.socket.readyState // Pour info
                });
                setconfirmDialogMicOpen(false);
                return;
            }
            mapSocketFactory.socket.emit('setMicState', {
                email: avatar?.email,
                mic_state: 0,
                sender: localAvatar?.display_name

            });
            console.log(`[Socket] setMicState émis via mapSocketFactory pour: ${avatar.email}`);
        } else {
            console.error("⛔ ÉCHEC ÉMISSION: La socket n'est pas disponible.");
        }
        setconfirmDialogMicOpen(false);
    };
    const {
        micActive,
        speakerActive,
        cameraActive,
        micLoading,

    } = useSelector((state) => state.mediaControls)

    const handleMicConfirmation = useCallback((data) => {
        if (!data) return;
        if (data.targetEmail === localAvatar?.email) {
            if (!globalLivekitMic) {
                if (micLoading) {
                    // Prevent toggling if already loading
                    dispatch(toggleLivekitMic(false))
                    return
                }
                if (!micActive) {
                    dispatch(setMicLoading(true))
                }
                dispatch(toggleLivekitMic(!micActive))
            }
            else {
                dispatch(toggleGlobalLivekitMic(false))
                dispatch(setIsSuperSpeakerActive(false))
            }
        }
    }
        , [micActive, micLoading, globalLivekitMic]);

    useEffect(() => {
        const socket = mapSocketFactory?.socket;
        if (!socket) return;
        socket.on('micClosed', handleMicConfirmation);
        return () => {
            socket.off('micClosed', handleMicConfirmation);
        };
    }, [handleMicConfirmation, mapSocketFactory?.socket]);




    const handleConfirmFire = useCallback(async () => {
        if (avatar?.email) {
            const deleteInvitation = await dispatch(findGuestTokenByEmail({ params: [{ email: avatar?.email }] }));
            const deleteInvitationId = deleteInvitation.payload.id;
            console.log("deleteInvitation", deleteInvitationId)
            dispatch(deactivateInvite({ params: [{ id: deleteInvitationId }] }));
            ///Emit socket event to notify server
            dispatch(FIRE_GUEST({
                avatarEmail: avatar?.email,
            }))

        }
        setConfirmDialogOpen(false);
    }, [avatar?.id, avatar?.email]);



    const handleConfirmFireUser = useCallback(async () => {
        if (avatar?.email) {
            const res = await dispatch(virerUser({ params: [{ email: avatar?.email }] }));
            console.log("retour virerUser ", res);
            const res2 = dispatch(EXCLUDE_USER({ email: avatar?.email, sender: localAvatar?.display_name }));
            console.log("retour socket ", res2);
        }
        setConfirmFireUserDialogOpen(false);
    }, [avatar?.id, avatar?.email]);

    useEffect(() => {
        console.log("AVATAR CHANGED", avatar);
    }, [avatar]);






    async function moveAvatarToChair(overlayId, chair, speed) {
        if (avatarBounds[0] === undefined || avatarBounds[1] === undefined)
            return;
        return new Promise((resolve) => {
            const avatarOverlay = overlays.current[overlayId];

            const startBounds = avatarOverlay.getBounds();
            const endBounds = L.latLngBounds(
                [
                    chair.lat + avatarBounds[0][0],
                    chair.lng - avatarBounds[0][1],
                ],
                [
                    chair.lat - avatarBounds[1][0],
                    chair.lng + avatarBounds[1][1],
                ],
            );
            const startTime = performance.now();

            // Fonction easing : accélération progressive puis ralentissement
            function easeInOutQuad(t) {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            }

            // Animation
            function animate(time) {
                const elapsedTime = time - startTime; // Temps écoulé
                const progress = Math.min(elapsedTime / speed, 1); // Progression entre 0 et 1
                const easedProgress = easeInOutQuad(progress); // Appliquer easing

                const interpolatedBounds = L.latLngBounds(
                    [
                        startBounds.getSouthWest().lat +
                        (endBounds.getSouthWest().lat -
                            startBounds.getSouthWest().lat) *
                        easedProgress,
                        startBounds.getSouthWest().lng +
                        (endBounds.getSouthWest().lng -
                            startBounds.getSouthWest().lng) *
                        easedProgress,
                    ],
                    [
                        startBounds.getNorthEast().lat +
                        (endBounds.getNorthEast().lat -
                            startBounds.getNorthEast().lat) *
                        easedProgress,
                        startBounds.getNorthEast().lng +
                        (endBounds.getNorthEast().lng -
                            startBounds.getNorthEast().lng) *
                        easedProgress,
                    ],
                );
                avatarOverlay.setBounds(interpolatedBounds); // Mise à jour de la position
                if (progress < 1) {
                    requestAnimationFrame(animate);
                }
            }
            requestAnimationFrame(animate);
        });
    }



    useEffect(() => {
        try {
            const scaleFactor = zoomLevel / mapConfig?.maxZoom;
            // Cleanup any orphaned tooltips from previous renders (for hot reload)
            const orphanedTooltips = document.querySelectorAll('.avatar-tooltip, .avatar-tooltip-arrow');
            orphanedTooltips.forEach(tooltip => {
                if (tooltip.parentNode) {
                    tooltip.parentNode.removeChild(tooltip);
                }
            });

            if (!chair || !avatar || !mapRef.current || !chair.lat || !chair.lng || !avatarBounds || !overlays.current) {
                console.warn("Chair or avatar data is missing or mapRef is not initialized.");
                return;
            }
            let element = null;
            const overlayId = "avatar-" + avatar.id;


            const bounds = L.latLngBounds(
                [
                    chair.lat + avatarBounds[0][0],
                    chair.lng - avatarBounds[0][1],
                ],
                [
                    chair.lat - avatarBounds[1][0],
                    chair.lng + avatarBounds[1][1],
                ],
            );
            const isCoffeeActive = (avatar?.break_coffe_time);
            const coffeeBarHtml = isCoffeeActive ? `
    <div class="coffee-status-bar-container"  
     style='transform: scale(${scaleFactor}) translateX(-50%);
                                transform-origin: bottom left;
                                left: 50%;
                bottom: 110%;'>
        <div class="coffee-status-bar-fill" style="width: ${progress}%"></div>
        <div class="coffee-status-content">
            <img src="${coffe}" class="coffee-icon" alt="coffee" />
            <span class="coffee-time">${timeLeft}</span>
        </div>
    </div>` : '';
            const html = `
            ${coffeeBarHtml}
            <div style="width: 100%; height: 100%; position: relative;">
     
             <div class="user-avatar ${avatar?.speaker_state === 0 ? "muted" : ""} user-avatar-on-map in-call" style="width: 100%; height: 100%; position: relative;">
               <rect class="avatar-volume" x="2" y="2" width="46" height="46" rx="18" stroke="#fa764e" strokeWidth="2" fill="#ffbd00" style="transform: scale(1,075);"></rect>
               <div class="avatar-connection-quality" data-tooltip="Qualité de connexion : ${t("connection_quality_" + (connectionQuality || "unknown"))}">
                 <img src="${connectionQualityIcon}" alt="Connection quality" />
               </div>
            
            <figure class="item-thumbnail user-avatar no-bg" style="position: relative;">
    ${videoTrack
                    ? `
        <div id="video-container-${avatar.id}" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: block; z-index: 2;"></div>
        `
                    : `
        ${avatar?.urlphoto === "Avatar.png"
                        ? getInitialAvatar(avatar?.firstName, avatar?.lastName)
                        : `<img src="${avatar?.urlphoto}" alt="${avatar?.name?.split(" ")[0]}">`
                    }
        `
                }
</figure>
               <div class="media-status ${avatar?.mic_state === 1 ||
                    avatar?.super_mic_state === 1
                    ? "status mic-on"
                    : ""
                }" style="display: initial;"></div>
               <div class="camera-status ${avatar?.camera_state === 1 ? "cam" : ""
                }"></div>
               <div class="screen-status ${avatar?.screenshare_state === 1 ? "share" : ""
                }"></div>
                <div class="focus-status ${avatar?.focus_state === 1 ? "focus" : ""
                }"></div>
               <div class="user-state state state-${avatar?.user_status}"></div>

               <span class="avatar-halo avatar-overlay"></span>

               <!-- Affichage conditionnel du display name -->
               <span class="item-tag nametag">
                 <span class="label">${avatar?.display_name}</span>
               </span>

               <!-- Barre d'actions masquée initialement -->
               ${avatar?.email !== localAvatar?.email // Affichez seulement si nécessaire
                    ? `<div class="action-bar">
                        ${tenantHasFeature("USER_CHAT_ENABLED") && hasPermission("sendMessageToUser") && avatar?.email !== localAvatar?.email
                        ? `<button class="action-button avatar-envelope" id="tooltip-envelope-${chair.id}" data-email="${avatar?.email}" data-tooltip="${t("SEND_MESSAGE")}">
                              <i class="fas fa-envelope"></i>
                              </button>`
                        : ""
                    }
                
                        ${hasPermission("pokeUser") && avatar?.email !== localAvatar?.email
                        ? `<button class="action-button poke-button" id="tooltip-poke-${chair.id}" data-email="${avatar?.email}" data-tooltip="${t("poke")}">
                                  <i class="fas fa-hand-point-up"></i>
                                </button>`
                        : ""
                    }

                        ${hasPermission("kickGuest") && avatar?.email !== localAvatar?.email &&
                        avatar?.is_guest === 1
                        ? `<button class="action-button fire-button" id="tooltip-fire-${chair.id}" data-email="${avatar?.email}" data-tooltip="${t("remove_guest")}">
                                  <i class="fas fa-user-xmark"></i>
                                </button>`
                        : ""
                    }

                 ${avatar?.email !== localAvatar?.email && isSameRoom &&
                        avatar?.is_guest === 0
                        ? `<button class="action-button fire-user-button" id="tooltip-fire-user-${chair.id}" data-email="${avatar?.email}" data-tooltip="${t("remove_user")}">
                                  <i class="fas fa-user-xmark"></i>
                                </button>`
                        : ""
                    }
                    ${(avatar?.mic_state === 1 || avatar?.super_mic_state === 1) && isSameRoom
                        ? `<button class="action-button mic-off" data-email="${avatar?.email}" data-tooltip="${t("close_mic_header")}">
                        <i class="fa-solid fa-microphone-slash"></i>
                      </button>`
                        : ""}
                     </div>`
                    : ""
                }
             </div>
           </div>`;

            if (!overlays.current[overlayId]) {

                overlays.current[overlayId] = new AvatarOverlay(
                    html,
                    bounds,
                    {
                        className: "custom-avatar-class",
                        interactive: true,
                        opacity: 1,
                        avatar: avatar,
                        chair_id: chair.id,
                    },
                );
                overlays.current[overlayId].addTo(mapRef.current);
            }
            else {
                const el = overlays.current[overlayId].getElement();
                if (el) {

                    const coffeeContainer = el.querySelector(".coffee-status-bar-container");
                    if (isCoffeeActive) {
                        if (coffeeContainer) {
                            const timeSpan = coffeeContainer.querySelector(".coffee-time");
                            const fillBar = coffeeContainer.querySelector(".coffee-status-bar-fill");

                            if (timeSpan) timeSpan.textContent = timeLeft;
                            if (fillBar) fillBar.style.width = `${progress}%`;
                            coffeeContainer.style.transform = `scale(${scaleFactor}) translateX(-50%)`;

                        } else {
                            el.insertAdjacentHTML('afterbegin', coffeeBarHtml);
                        }
                    } else if (coffeeContainer) {
                        coffeeContainer.remove();
                    }
                    else {
                        el.innerHTML = html;

                    }
                }
            }

            element = overlays.current[overlayId].getElement();
            element.style.zIndex = 401;

            const figureEl = element?.querySelector("figure.item-thumbnail");
            const handleFigureClick = (e) => {
                e.preventDefault(); 
                e.stopPropagation(); 

                setSelectedAvatar(avatar);
                setIsModalOpen(true);
            };

            figureEl?.removeEventListener("click", handleFigureClick);
            figureEl?.addEventListener("click", handleFigureClick);

            //Animate movement
            if (
                overlays.current[overlayId].options?.avatar &&
                overlays.current[overlayId].options?.chair_id !== chair.id
            ) {
                overlays.current[overlayId].options.chair_id = null;
                moveAvatarToChair(
                    overlayId,
                    chair,
                    1000,
                )
                    .then(() => {
                        console.log(
                            `Avatar ${avatar.id} moved to chair ${chair.id}`,
                        );
                    })
                    .catch((error) => {
                        console.error(
                            "Erreur lors du déplacement de l'avatar :",
                            error,
                            avatar,
                        );
                    });
            }


            // UI State handling
            if (element) {
                try {
                    element.classList.add("active");

                    const videoContainer = element.querySelector(`#video-container-${avatar.id}`);

                    if (videoTrack && isSameRoom) {
                        let videoEl = videoContainer.querySelector('video');

                        if (!videoEl) {
                            videoEl = document.createElement('video');
                            videoEl.autoplay = true;
                            videoEl.playsInline = true;
                            videoEl.muted = true;
                            videoContainer.appendChild(videoEl);
                        }

                        if (!videoEl.srcObject) {
                            videoEl.srcObject = new MediaStream([videoTrack.mediaStreamTrack]);
                        }

                    }
                    // États caméra, micro, partage d'écran, etc.
                    element
                        .querySelector(".camera-status")
                        ?.classList.toggle(
                            "cam",
                            avatar?.camera_state === 1,
                        );
                    element
                        .querySelector(".screen-status")
                        ?.classList.toggle(
                            "share",
                            avatar?.screenshare_state === 1,
                        );
                    element
                        .querySelector(".media-status")
                        ?.classList.toggle(
                            "mic-on",
                            avatar?.mic_state === 1 ||
                            avatar?.super_mic_state === 1,
                        );

                    element
                        .querySelector(".media-status")
                        ?.classList.toggle(
                            "status",
                            avatar?.mic_state === 1 ||
                            avatar?.super_mic_state === 1,
                        );

                    element
                        .querySelector(".user-avatar")
                        ?.classList.toggle(
                            "muted",
                            avatar?.speaker_state === 0,
                        );
                    element
                        .querySelector(".focus-status")
                        ?.classList.toggle(
                            "focus",
                            avatar?.focus_state === 1,
                        );
                    // État utilisateur
                    const userStateElement =
                        element.querySelector(".user-state");
                    userStateElement?.classList.forEach((cls) => {
                        if (cls.startsWith("state-")) {
                            userStateElement.classList.remove(cls);
                        }
                    });
                    if (avatar?.user_status !== undefined) {
                        userStateElement.classList.add(
                            `state-${avatar?.user_status}`,
                        );
                    }

                    element.addEventListener("mouseover", () => {
                        element
                            .querySelector(".item-tag")
                            ?.style.setProperty("display", "initial");
                        element
                            .querySelector(".focus-status")
                            ?.style.setProperty("display", "none");
                        const coffeeBar = element.querySelector(".coffee-status-bar-container");
                        if (coffeeBar) {
                            coffeeBar.style.setProperty("display", "none");
                        }
                        element.style.zIndex = 602;
                    });

                    element.addEventListener("mouseout", () => {
                        element
                            .querySelector(".item-tag")
                            ?.style.setProperty("display", "none");
                        element
                            .querySelector(".focus-status")
                            ?.style.removeProperty("display");
                        const coffeeBar = element.querySelector(".coffee-status-bar-container");
                        if (coffeeBar) {
                            coffeeBar.style.removeProperty("display");
                        }
                        element.style.zIndex = 401;
                    });

                    element
                        .querySelector(".avatar-envelope")
                        ?.addEventListener("click", handleMessageClick);

                    element
                        .querySelector(".poke-button")
                        ?.addEventListener("click", handlePokeClick);

                    element
                        .querySelector(".fire-button")
                        ?.addEventListener("click", handleFireClick);
                    element
                        .querySelector(".fire-user-button")
                        ?.addEventListener("click", handleFireUserClick);
                    element
                        .querySelector(".mic-off")
                        ?.addEventListener("click", handleCloseMicClick);

                    // Setup tooltips with fixed positioning to ensure they appear above everything
                    const setupTooltip = (button) => {
                        if (!button || !button.dataset.tooltip) return;

                        let tooltipEl = null;
                        let arrowEl = null;

                        const showTooltip = (e) => {
                            if (tooltipEl) return; // Already showing

                            const rect = button.getBoundingClientRect();
                            const tooltipText = button.dataset.tooltip;

                            if (!tooltipText) return;

                            // Create tooltip element
                            tooltipEl = document.createElement('div');
                            tooltipEl.className = 'avatar-tooltip';
                            tooltipEl.textContent = tooltipText;
                            tooltipEl.style.cssText = `
                                position: fixed;
                                background-color: #ffffff;
                                color:rgb(0, 0, 0);
                                font-size: 0.875rem;
                                border-radius: 0.5rem;
                                padding: 0.5rem 0.75rem;
                                font-family: "Roboto", sans-serif;
                                white-space: nowrap;
                                z-index: 99999;
                                box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 
                                           0px 6px 10px 0px rgba(0,0,0,0.14), 
                                           0px 1px 18px 0px rgba(0,0,0,0.12);
                                pointer-events: none;
                                opacity: 0;
                                transition: opacity 0.2s ease-in-out;
                                left: -9999px;
                                top: -9999px;
                                                                font-weight: 600;

                            `;

                            // Create arrow element
                            arrowEl = document.createElement('div');
                            arrowEl.className = 'avatar-tooltip-arrow';
                            arrowEl.style.cssText = `
                                position: fixed;
                                width: 0;
                                height: 0;
                                border-style: solid;
                                border-width: 0.3125rem 0.3125rem 0 0.3125rem;
                                border-color: #ffffff transparent transparent transparent;
                                z-index: 99999;
                                pointer-events: none;
                                transition: opacity 0.2s ease-in-out;
                                filter: drop-shadow(0px 2px 2px rgba(0,0,0,0.1));
                               
                            `;

                            document.body.appendChild(tooltipEl);
                            document.body.appendChild(arrowEl);

                            // Wait for element to be in DOM, then calculate position
                            requestAnimationFrame(() => {
                                const tooltipRect = tooltipEl.getBoundingClientRect();

                                // Position tooltip above button
                                const tooltipTop = rect.top - tooltipRect.height - 8;
                                const tooltipLeft = rect.left + (rect.width / 2) - (tooltipRect.width / 2);

                                tooltipEl.style.top = `${tooltipTop}px`;
                                tooltipEl.style.left = `${tooltipLeft}px`;

                                // Position arrow - collée directement sous la bulle
                                const arrowTop = tooltipTop + tooltipRect.height;
                                const arrowLeft = rect.left + (rect.width / 2) - 5;

                                arrowEl.style.top = `${arrowTop}px`;
                                arrowEl.style.left = `${arrowLeft}px`;

                                // Trigger animation
                                requestAnimationFrame(() => {
                                    tooltipEl.style.opacity = '1';
                                    arrowEl.style.opacity = '1';
                                });
                            });
                        };

                        const hideTooltip = () => {
                            if (tooltipEl) {
                                tooltipEl.style.opacity = '0';
                                arrowEl.style.opacity = '0';
                                setTimeout(() => {
                                    if (tooltipEl && tooltipEl.parentNode) {
                                        tooltipEl.parentNode.removeChild(tooltipEl);
                                    }
                                    if (arrowEl && arrowEl.parentNode) {
                                        arrowEl.parentNode.removeChild(arrowEl);
                                    }
                                    tooltipEl = null;
                                    arrowEl = null;
                                }, 200);
                            }
                        };

                        button.addEventListener('mouseenter', showTooltip);
                        button.addEventListener('mouseleave', hideTooltip);

                        return () => {
                            button.removeEventListener('mouseenter', showTooltip);
                            button.removeEventListener('mouseleave', hideTooltip);
                            if (tooltipEl && tooltipEl.parentNode) {
                                tooltipEl.parentNode.removeChild(tooltipEl);
                            }
                            if (arrowEl && arrowEl.parentNode) {
                                arrowEl.parentNode.removeChild(arrowEl);
                            }
                        };
                    };

                    // Setup tooltips for all action buttons
                    const actionButtons = element.querySelectorAll('.action-button[data-tooltip], .avatar-connection-quality[data-tooltip]');
                    const cleanupTooltips = [];
                    actionButtons.forEach(btn => {
                        const cleanup = setupTooltip(btn);
                        if (cleanup) cleanupTooltips.push(cleanup);
                    });

                    // Store cleanup functions for this element
                    if (!element._tooltipCleanups) {
                        element._tooltipCleanups = [];
                    }
                    element._tooltipCleanups.push(...cleanupTooltips);



                } catch (error) {
                    console.error('Error manipulating avatar element:', error);
                }
            }


            return () => {
                if (element != null) {
                    element
                        .querySelector(".avatar-envelope")
                        ?.removeEventListener("click", handleMessageClick);
                    element
                        .querySelector(".poke-button")
                        ?.removeEventListener("click", handlePokeClick);
                    element
                        .querySelector(".fire-button")
                        ?.removeEventListener("click", handleFireClick);
                    element
                        .querySelector(".fire-user-button")
                        ?.removeEventListener("click", handleFireUserClick);
                    element
                        .querySelector(".mic-off")
                        ?.removeEventListener("click", handleCloseMicClick);

                    // Cleanup tooltip event listeners
                    if (element._tooltipCleanups) {
                        element._tooltipCleanups.forEach(cleanup => cleanup());
                        element._tooltipCleanups = [];
                    }

                    // Cleanup any orphaned tooltips in the DOM (for hot reload)
                    const tooltips = document.querySelectorAll('.avatar-tooltip, .avatar-tooltip-arrow');
                    tooltips.forEach(tooltip => {
                        if (tooltip.parentNode) {
                            tooltip.parentNode.removeChild(tooltip);
                        }
                    });

                    figureEl?.removeEventListener("click", handleFigureClick);
                }


            };
        } catch (error) {
            console.error('Error in Avatar component:', error);
        }

    }, [avatar, chair, avatarBounds, permissions, connectionQuality, connectionQualityIcon, isSameRoom, avatar?.break_coffe_time, cafePauseActive, cafePauseDuration, timeLeft, zoomLevel, mapConfig, videoTrack, isMobile]);



    const handleCloseCard = useCallback(() => {
        setIsModalOpen(false)
    }, [])


    return (
        <>

            {isModalOpen && (
                <Modal
                    isOpen={true}
                    onClose={handleCloseCard}
                    hasHeader={false}
                    className={'paper Profile-info'}
                >
                    <ProfileInfo isOpen={true} Profile={selectedAvatar}/>
                </Modal>
            )}


            <ActionConfirmation
                open={confirmDialogOpen}
                onClose={() => setConfirmDialogOpen(false)}
                onConfirm={handleConfirmFire}
                title="Retirer l'invité"
                msg="Cette action va retirer cet invité de la session. L'invité ne pourra plus accéder à cette session. Êtes-vous sûr de vouloir continuer ?"
                variant="destructive"
                cancelText="Annuler"
                confirmText="Retirer"
            />
            <ActionConfirmation
                open={ConfirmFireUserDialogOpen}
                onClose={() => setConfirmFireUserDialogOpen(false)}
                onConfirm={handleConfirmFireUser}
                title={t("virer_utilisateur_header")}
                msg={t("virer_utilisateur", { name: avatar?.display_name })}
                variant="destructive"
                cancelText={t("cancel")}
                confirmText={t("confirm")}
            />
            <ActionConfirmation
                open={confirmDialogMiCOpen}
                title={t("close_mic_header")}
                msg={t("couper_Micor")}
                cancelText={t("cancel")}
                confirmText={t("confirm")}
                icon="mic_off"
                onClose={() => setconfirmDialogMicOpen(false)}
                onConfirm={handleConfirmCloseMic}
            />
        </>
    );
};

export default Avatar;